import { SplitContentConfigRendererDynamicTemplate } from "./SplitContentConfigRendererDynamicTemplate";
import { SplitContentNodeContent } from "../splitContentTypes";
import { SplitContentConfigRendererContentGroup } from "./SplitContentConfigRendererContentGroup";
import { SplitContentConfigRendererChannel } from "./SplitContentConfigRendererChannel";
import { DsPlayerItemRenderer } from "@/components/ds/player/playType/DsPlayerItemRenderer";
import { generatePlaylist } from "@/components/ds/lib/DSPlaylistGenerator";
import { DSContent } from "@/components/ds/lib/types";
import { ContentType } from "@/lib/types";
import { SplitContentConfigRendererCampaign } from "./SplitContentConfigRendererCampaign";

interface Props {
  node: SplitContentNodeContent;
}

export const SplitContentConfigRenderer: React.FC<Props> = ({ node }) => {
  if (!node || !node.type || !node.config) {
    return null;
  }

  const { type, config } = node;
  if (type !== "content") {
    return null;
  }

  const attachConfigType = config.type;

  if (attachConfigType === "content") {
    const { contentType, src } = config;
    if (contentType?.startsWith("image") || contentType === "dynamic/fromTemplate") {
      const playlistItem: DSContent<Date> = {
        contentId: "1",
        contentintId: 1,
        contentStorageName: src,
        contentDuration: 1000,
        contentType: contentType as ContentType,
        layoutConfig: config.layoutConfig,
        startDate: new Date(),
        endDate: new Date(),
        contentLink: "",
        screenSizeHeight: 0,
        screenSizeWidth: 0,
        screenSizeId: "",
        screenSizeintId: 0,
      };
      return (
        <DsPlayerItemRenderer
          item={generatePlaylist([playlistItem], undefined, { width: 0, height: 0 })[0]}
          isFullScreen={false}
          onVideoEnded={() => {}}
          onAudioEnded={() => {}}
        />
      );
    }
    if (contentType?.startsWith("video")) {
      return <video src={src} muted autoPlay controls={false} loop className="w-full h-full" />;
    }
    return <div className="mt-4">Unsupported content type</div>;
  }

  if (attachConfigType === "html") {
    return <div dangerouslySetInnerHTML={{ __html: config.html }} />;
  }

  if (attachConfigType === "url") {
    return <iframe src={config.url} name="myiFrame" width="100%" height="100%" allowFullScreen></iframe>;
  }

  if (attachConfigType === "dynamic-template") {
    return <SplitContentConfigRendererDynamicTemplate config={config} />;
  }

  if (attachConfigType === "content-group") {
    return <SplitContentConfigRendererContentGroup config={config} />;
  }

  if (attachConfigType === "channel") {
    return <SplitContentConfigRendererChannel config={config} />;
  }

  if (attachConfigType === "campaign") {
    return <SplitContentConfigRendererCampaign config={config} />;
  }

  return <div>{JSON.stringify(node)}</div>;
};
